module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sky-overlay-toggle",
    class: [{
      active: _vm.active
    }, _vm.name],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOverlay($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-6ed90082"}!./scripts/sky-overlay/sky-overlay-toggle.html
// module id = 358
// module chunks = 1